import { UseFormRegister } from 'react-hook-form';

interface FormValues {
  [key: string]: string;
}

interface DataEntryFormFieldProps {
  field: string;
  type: string;
  label: string;
  placeholder: string;
  register: UseFormRegister<FormValues>;
}

const DataEntryFormField = ({ field, type, label, placeholder, register }: DataEntryFormFieldProps) => {
  return (
    <div className='entry-field'>
      <label htmlFor={field}>{label.toUpperCase()}</label>
      <input placeholder={placeholder} required type={type} id={field} {...register(field)} />
    </div>
  );
};

export default DataEntryFormField;